import get from 'lodash.get';

const getUpdatedAt = (rootState) => get(rootState, 'ws.site.updatedAt', null);

export default getUpdatedAt;
